import Vue from "vue";
import VueRouter from "vue-router";
import { routes } from "./routes";
Vue.use( VueRouter );


const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior( to, from, savedPosition ){
    if (savedPosition) {
      //document.querySelector("body").scrollTo(0,0)
      return savedPosition
    } else {
      if (to.hash) {
        return {
          selector: to.hash
        }
      }
    }
    document.querySelector("body").scrollTo(0,0)
    return savedPosition ? savedPosition : { x: 0, y: 0 };
  }
});

export default router;
